export const DOCUMENT_ID = 'document';
